import React from 'react';

const TrashIcon = () => (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.91667 2.02778H11.1389V2.58333H1.25V2.02778H3.47222H3.67933L3.82578 1.88133L4.45711 1.25H7.93178L8.56311 1.88133L8.70956 2.02778H8.91667ZM3.08333 14.25C2.50392 14.25 2.02778 13.7739 2.02778 13.1944V4.36111H10.3611V13.1944C10.3611 13.7739 9.88497 14.25 9.30556 14.25H3.08333Z" fill="#8295AF" stroke="#8295AF" />
    </svg>

);

export default TrashIcon;
